"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
require("./ParlanceForm.css");
var _Question = _interopRequireDefault(require("./Question/Question"));
var _FormNav = _interopRequireDefault(require("./FormNav/FormNav"));
var _AnswerValidator = _interopRequireDefault(require("../../utility/Forms/AnswerValidator"));
var _SlideDirection = require("../../utility/Forms/SlideDirection");
var _InterstitialScreen = _interopRequireDefault(require("./InterstitialScreen/InterstitialScreen"));
var _StepType = require("../../utility/Forms/StepType");
var _FormulaParser = _interopRequireDefault(require("../../utility/Forms/FormulaParser"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ParlanceForm = function ParlanceForm(props) {
  var _props$theme;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentStepIndex = _useState2[0],
    setCurrentStepIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    previousStepNumber = _useState4[0],
    setPreviousStepNumber = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    answersByName = _useState6[0],
    setAnswersByName = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    invalidAnswerSubmitted = _useState8[0],
    setInvalidAnswerSubmitted = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    didSubmitAnswer = _useState10[0],
    setDidSubmitAnswer = _useState10[1];
  var _useState11 = (0, _react.useState)(1),
    _useState12 = _slicedToArray(_useState11, 2),
    currentDisplayStep = _useState12[0],
    setCurrentDisplayStep = _useState12[1];
  var _useState13 = (0, _react.useState)(function () {
      return getStepCount(false);
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    totalDisplaySteps = _useState14[0],
    setTotalDisplaySteps = _useState14[1];
  var _useState15 = (0, _react.useState)(1),
    _useState16 = _slicedToArray(_useState15, 2),
    currentQuestionDisplayNumber = _useState16[0],
    setCurrentQuestionDisplayNumber = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    wasFormSubmitted = _useState18[0],
    setWasFormSubmitted = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showLoadingIndicatorForSubmitButton = _useState20[0],
    setShowLoadingIndicatorForSubmitButton = _useState20[1];
  var stepRefs = (0, _react.useRef)(props.steps.map(function () {
    return /*#__PURE__*/(0, _react.createRef)();
  }));
  var answersById = (0, _react.useRef)({});
  var conditionalDisplayDependencies = (0, _react.useRef)(new Array(props.steps.length)); // This method stores a list of the dependencies, their previously calculated values, and the function result for conditional display questions. We need to keep track of these so that we do not call the Hyperformula module repeatedly (a compute-heavy method that slows down the browser) every time a question changes.

  (0, _react.useEffect)(function () {
    // Check to see if the current step is a variable setting step
    if (currentStepIndex >= props.steps.length) {
      return;
    }
    if (props.steps[currentStepIndex].type == _StepType.StepType.SetVariable) {
      setVariableAndNavigateToNextStep();
    } else {
      setCurrentDisplayStep(getStepCount(true) + 1);
      setTotalDisplaySteps(getStepCount(false));
      setCurrentQuestionDisplayNumber(getQuestionDisplayNumber(currentStepIndex));
    }
  }, [currentStepIndex]);
  function setAnswer(id, answer) {
    var navigateToNextStep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    answersById.current[id] = answer;
    var stepName = getStepNameFromId(id);
    if (stepName) {
      answersByName[stepName] = answer;
      setAnswersByName(answersByName);
    }
    var currentStep = props.steps[currentStepIndex];
    var currentAnswer = answersById.current[currentStep.id];
    if (invalidAnswerSubmitted) {
      if (currentAnswer && currentAnswer !== "" && currentAnswer.length > 0) {
        setInvalidAnswerSubmitted(false);
        setDidSubmitAnswer(false);
      }
    }
    if (navigateToNextStep) {
      navigateToScreen(currentStepIndex + 1);
    }
  }
  function getStepNameFromId(id) {
    var _iterator = _createForOfIteratorHelper(props.steps),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var stepData = _step.value;
        if (stepData.id && stepData.id === id) {
          return stepData.name;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return null;
  }
  function getIndexOfNextVisibleScreenMovingForwards(nextStepIndex) {
    for (var index = nextStepIndex; index < props.steps.length; index++) {
      var currentStep = props.steps[index];
      if (!currentStep.displayConditions || shouldQuestionBeDisplayed(index)) {
        return index; // In this case, we can set the next screen to be the next step. If that step is a variable, then the variable will be calculated and will then instruct the form to move forward. Our bigger concern is moving backwards.
      }
    }

    return props.steps.length;
  }
  function getIndexOfNextVisibleScreenMovingBackwards(nextStepIndex) {
    for (var index = nextStepIndex; index >= 0; index--) {
      var currentStep = props.steps[index];
      if (currentStep.type !== _StepType.StepType.SetVariable && (!currentStep.displayConditions || shouldQuestionBeDisplayed(index))) {
        return index;
      }
    }
  }
  function getIndexOfNextVisibleScreen(nextStepIndex) {
    var direction = "forwards";
    if (currentStepIndex > nextStepIndex) {
      direction = "backwards";
    }
    if (direction == "forwards") {
      return getIndexOfNextVisibleScreenMovingForwards(nextStepIndex);
    }
    return getIndexOfNextVisibleScreenMovingBackwards(nextStepIndex);
  }
  function haveVariablesForConditionalDisplayChanged(questionIndex, newVariableCalculations) {
    var shouldOverwriteExistingVariablesIfDifferent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // This method checks to see if any values that govern whether a question is displayed have changed. If they have, then we will re-run calculations, but if not, we will return the previously calculated results
    if (!conditionalDisplayDependencies.current) {
      throw "Conditional display dependencies not set";
    }
    if (newVariableCalculations && Object.keys(newVariableCalculations).length > 0) {
      if (!conditionalDisplayDependencies.current[questionIndex]) {
        conditionalDisplayDependencies.current[questionIndex] = {
          variables: {}
        };
      }
      var existingCalculatedVariables = conditionalDisplayDependencies.current[questionIndex].variables;
      var newValuesFound = false;
      if (!existingCalculatedVariables) {
        newValuesFound = true;
        conditionalDisplayDependencies.current[questionIndex].variables = {};
      }
      for (var _i2 = 0, _Object$entries = Object.entries(newVariableCalculations); _i2 < _Object$entries.length; _i2++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        var existingValue = conditionalDisplayDependencies.current[questionIndex].variables[key];
        if (existingValue !== value) {
          newValuesFound = true;
          if (shouldOverwriteExistingVariablesIfDifferent) {
            conditionalDisplayDependencies.current[questionIndex].variables[key] = value;
          }
        }
      }
      return newValuesFound;
    }
    return false;
  }
  function shouldQuestionBeDisplayed(questionIndex) {
    try {
      var question = props.steps[questionIndex];
      if (!question) {
        return false;
      }
      if (!question.displayConditions) {
        return true;
      }
      try {
        var variables = _FormulaParser.default.getVariablesAndValues(question.displayConditions, answersByName);
        if (haveVariablesForConditionalDisplayChanged(questionIndex, variables, true)) {
          var result = _FormulaParser.default.executeFormula(question.displayConditions, answersByName);
          conditionalDisplayDependencies.current[questionIndex].result = result;
          return result;
        } else {
          return conditionalDisplayDependencies.current[questionIndex].result;
        }
      } catch (message) {
        if (message.indexOf("variables") >= 0) {
          return false;
        }
      }
    } catch (ex) {
      return true;
    }
  }
  function getQuestionDisplayNumber(stepIndex) {
    // This method calculates the current question number that should be displayed to the user

    var questionDisplayNumber = 0;
    for (var index = 0; index <= stepIndex; index++) {
      var currentStep = props.steps[index];
      if (currentStep.type == _StepType.StepType.SetVariable || currentStep.type == _StepType.StepType.InterstitialScreen || !shouldQuestionBeDisplayed(index)) {
        continue;
      }
      questionDisplayNumber++;
    }
    return questionDisplayNumber;
  }
  function getStepCount() {
    var getCurrentIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var stepsToSubtract = 0;
    var max = currentStepIndex;
    if (!getCurrentIndex) {
      max = props.steps.length;
    }
    for (var index = 0; index < max; index++) {
      if (props.steps[index].type == _StepType.StepType.SetVariable || !shouldQuestionBeDisplayed(index)) {
        stepsToSubtract++;
      }
    }
    return max - stepsToSubtract;
  }
  function shouldNextScreenShowFinalPage(nextStepIndex) {
    // First check to see if we're on the last page
    if (nextStepIndex > props.steps.length - 1) {
      return true;
    }

    // Now check to see if we're not on the last page but all subsequent pages cannot be shown
    for (var index = nextStepIndex; index <= props.steps.length - 1; index++) {
      var step = props.steps[index];
      if (step.type === _StepType.StepType.InterstitialScreen || step.type === _StepType.StepType.Question && shouldQuestionBeDisplayed(index)) {
        return false;
      }
    }
    return true;
  }
  function navigateToScreen(nextStepIndex) {
    if (currentStepIndex >= props.steps.length - 1 && nextStepIndex == props.steps.length - 1) {
      setInvalidAnswerSubmitted(false);
      setDidSubmitAnswer(false);
      setPreviousStepNumber(currentStepIndex);
      setCurrentStepIndex(props.steps.length - 1);
      return;
    }
    var currentStep = props.steps[currentStepIndex];
    var currentAnswer = answersById.current[currentStep.id];

    // Don't let people move forward if they have an invalid answer
    if (nextStepIndex > currentStepIndex && !_AnswerValidator.default.isAnswerValid(currentStep, currentAnswer)) {
      setInvalidAnswerSubmitted(true);
      return;
    }
    setInvalidAnswerSubmitted(false);
    setDidSubmitAnswer(false);
    setPreviousStepNumber(currentStepIndex);

    // If they're on the last question, send them to the submission page
    if (shouldNextScreenShowFinalPage(nextStepIndex)) {
      setPreviousStepNumber(currentStepIndex);
      setCurrentStepIndex(props.steps.length);
    } else {
      // We need to set the step to the index of the previous/next visible screen
      var indexOfNextScreen = getIndexOfNextVisibleScreen(nextStepIndex);
      setCurrentStepIndex(indexOfNextScreen);
    }
  }
  function getSlideDirectionForStep(step) {
    if (previousStepNumber !== null && previousStepNumber > step) {
      return _SlideDirection.SlideDirection.Down;
    }
    return _SlideDirection.SlideDirection.Up;
  }
  function getExistingAnswerValue(index) {
    var step = props.steps[index];
    if (step) {
      return answersById.current[step.id];
    }
    return null;
  }
  function setVariableAndNavigateToNextStep() {
    var value = _FormulaParser.default.executeFormula(props.steps[currentStepIndex].formula, answersByName);
    setAnswer(props.steps[currentStepIndex].id, value, true);
  }
  function getAnswersForSubmission() {
    var validAnswerValues = new Map();
    var _iterator2 = _createForOfIteratorHelper(props.steps),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var step = _step2.value;
        if (step.type === _StepType.StepType.InterstitialScreen || step.type === _StepType.StepType.SetVariable && props.filterOutCalculatedVariables) {
          continue;
        }
        var key = (props.returnAnswersByName ? step.name : step.id).toString();
        var stepId = step.id;
        validAnswerValues.set(key, answersById.current[stepId]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return validAnswerValues;
  }
  function submitForm() {
    setShowLoadingIndicatorForSubmitButton(true);
    var returnValue = getAnswersForSubmission();
    props.submitAnswers(returnValue, function (successFlag) {
      setShowLoadingIndicatorForSubmitButton(false);
      if (successFlag) {
        setWasFormSubmitted(true);
      }
    });
  }
  function renderTitleBar() {
    var _objectSpread2;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "title-bar",
      children: [props.logoUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: props.logoDestinationUrl || "#",
        className: "logo",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: props.logoUrl
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}), wasFormSubmitted ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormNav.default, _objectSpread((_objectSpread2 = {
        currentStepIndex: currentStepIndex,
        steps: props.steps,
        navigateToScreen: navigateToScreen,
        currentStep: currentDisplayStep,
        totalSteps: totalDisplaySteps
      }, _defineProperty(_objectSpread2, "steps", props.steps), _defineProperty(_objectSpread2, "answers", answersByName), _objectSpread2), props))]
    });
  }
  function renderEndScreenIfNeeded() {
    if (currentStepIndex >= props.steps.length) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InterstitialScreen.default, _objectSpread({
        setAnswer: setAnswer,
        slideDirection: _SlideDirection.SlideDirection.Up,
        submitForm: submitForm,
        isEndScreen: true,
        endScreenPrompt: props.endScreenPrompt,
        wasFormSubmitted: wasFormSubmitted,
        loading: showLoadingIndicatorForSubmitButton,
        answers: answersByName
      }, props));
    }
    return null;
  }
  function renderFormStep(step, index) {
    var Component = null;
    switch (step.type) {
      case _StepType.StepType.Question:
        Component = _Question.default;
        break;
      case _StepType.StepType.InterstitialScreen:
        Component = _InterstitialScreen.default;
        break;
      default:
        break;
    }
    return !Component || !shouldQuestionBeDisplayed(index) || currentStepIndex !== index ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, _objectSpread({
      data: step,
      ref: stepRefs.current[index],
      setAnswer: setAnswer,
      slideDirection: getSlideDirectionForStep(index),
      invalidAnswerSubmitted: invalidAnswerSubmitted,
      existingAnswerValue: getExistingAnswerValue(index),
      didSubmitAnswer: didSubmitAnswer,
      onSubmit: function onSubmit() {
        setDidSubmitAnswer(true);
      },
      questionDisplayNumber: currentQuestionDisplayNumber,
      isEndScreen: currentStepIndex >= props.steps.length,
      endScreenPrompt: props.endScreenPrompt,
      answers: answersByName
    }, props), step.id);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "form",
    role: "document",
    style: ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.global) || null,
    children: [renderTitleBar(), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "form-content-wrapper",
      children: [renderEndScreenIfNeeded(), props.steps.map(function (step, index) {
        return renderFormStep(step, index);
      })]
    })]
  });
};
var _default = ParlanceForm;
exports.default = _default;